import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { TareaEjecucionService } from "../../../generated/grpc/rastro_tarea_ejecucion_pb";
import { grpcTareaEjecucionDatabase } from "../database/GrpcTareaEjecucionDatabase";
import { TareaEjecucionResponse } from "../response/TareaEjecucionResponse";

/** Variante gRPC-Web de `TareaEjecucionDeleteService` (ver ese archivo). No
 *  invalida ningún cooldown -mismo motivo que `TareaEjecucionSaveGrpcService`-:
 *  `deleteOneAsync` ya la saca de `GrpcTareaEjecucionDatabase` al toque. */
export class TareaEjecucionDeleteGrpcService
  implements IDeleteService<TareaEjecucionResponse>
{
  async deleteAsync(item: TareaEjecucionResponse): Promise<void> {
    const client = createClient(TareaEjecucionService, grpcTransportProvider.get());

    try {
      await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcTareaEjecucionDatabase.deleteOneAsync(item.id);
  }
}
